// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"13d47fb1","513":"f51d9b06","703":"fbed3615","787":"269cec5d"}[chunkId] + ".chunk.js";
};